import React from 'react'
import { Outlet } from 'react-router'
import Header from '../header/header'
import SideBar from '../sidebar/sideBar'

interface Props { }

function DashboardLayout(props: Props) {
    const { } = props

    return (
       <>
            <Header />

            <div className="flex bg-[#F7F7FB] h-[100vh] w-full overflow-x-hidden">
                <SideBar />

                <main className=" w-[100%] min-w-0">
                    <Outlet />
                </main>
            </div>
        </>
    )
}

export default DashboardLayout
